import styled from 'styled-components';
import { Title } from '@lux/title';
import { screenSizes } from '@lux/tokens';

export const StyledSectionTitleWrapper = styled.div`
    padding: 3% 14px;

    @media screen and (min-width: ${screenSizes.sm}px) {
        padding: 3% 0 0;
    }

    & > ${Title} {
        border: none;
        margin: 20px 0 0;
        padding: 23px 0 0;
        text-transform: none;
    }
`;
